import { render, staticRenderFns } from "./InventoryTab.vue?vue&type=template&id=1f4ed042&scoped=true&lang=pug&"
import script from "./InventoryTab.vue?vue&type=script&lang=js&"
export * from "./InventoryTab.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTab.vue?vue&type=style&index=0&id=1f4ed042&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ed042",
  null
  
)

export default component.exports